import { useState } from "react";
import { InputText, Select } from "../../components/Input";

import companySchema from "../../data/companySchema";
import { SignatureData } from "../../types/SignatureData";
import { parseCompanySchemaToOptions } from "../../utils/parseCompanySchemaToOptions";

import downloadIcon from "../../assets/icons/icon-24-download.svg";
import {
  generateEmlTemplate,
  generateTemplate,
} from "../../utils/generateTemplate";

import { CompanyEnums } from "../../types/CompanySchema";
import { downloadFile } from "../../utils/downloadFile";
import { buildEmlFileName } from "../../utils/buildEmlFile";
import { AppleMailInstructions } from "./components/AppleMailInstructions";
import { Helmet } from "react-helmet";

const companiesList = parseCompanySchemaToOptions(companySchema);

/**
 * SignGenerator.tsx
 * The SignGenerator page
 */
export const SignGenerator = () => {
  const [formData, setFormData] = useState<SignatureData>({});
  const [emlFileName, setEmlFileName] = useState<string>();

  const selectedCompany = companySchema.find((c) => c.id === formData.company);

  const handleCompanyChange = (company: string) =>
    setFormData((formData) => ({
      ...formData,
      company: company as CompanyEnums,
    }));

  const handleDataChange = (id: string) => (value: string) =>
    setFormData((formData) => ({ ...formData, [id]: value }));

  const handleSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    const htmlFileToDownload = await generateTemplate(formData);

    if (htmlFileToDownload) {
      downloadFile(
        `${formData.name}-${formData.company}-email_signature.html`,
        htmlFileToDownload
      );
    }
  };

  const handleMacSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    const emlFileToDownload = await generateEmlTemplate(formData);

    if (emlFileToDownload) {
      const fileName = buildEmlFileName(formData.name || "");

      downloadFile(fileName, emlFileToDownload);
      setEmlFileName(fileName);
    }
  };

  const areRequiredFilled = selectedCompany?.schema.every(({ id, required }) =>
    required ? formData[id] : true
  );

  return (
    <>
      <Helmet>
        <title>HVM Dashboard | Nuova firma</title>
      </Helmet>
      <div className="container mx-auto py-12">
        <div className="flex justify-center">
          <div>
            <h1 className="mb-8 text-3xl font-semibold leading-10">
              Genera una nuova firma
            </h1>
            <form>
              <div className="grid grid-cols-2 gap-x-6 gap-y-12 justify-center">
                <Select
                  value={formData?.company}
                  onChange={handleCompanyChange}
                  label="Azienda"
                  placeholder="Seleziona un'azienda"
                  options={companiesList}
                />
                {selectedCompany &&
                  selectedCompany.schema.map((v) => (
                    <InputText
                      {...v}
                      value={formData[v.id]}
                      onChange={handleDataChange(v.id)}
                    />
                  ))}
              </div>

              <div className="mt-12 grid grid-cols-2 gap-6">
                <button
                  className="btn btn-primary flex items-center gap-2 justify-center transition-opacity disabled:opacity-50"
                  onClick={handleSubmit}
                  disabled={!areRequiredFilled}
                >
                  <img src={downloadIcon} alt="Download icon" />
                  Genera Firma e Scarica Codice
                </button>
                <button
                  className="btn btn-secondary flex items-center gap-2 justify-center transition-opacity disabled:opacity-50"
                  onClick={handleMacSubmit}
                  disabled={!areRequiredFilled}
                >
                  <img src={downloadIcon} alt="Download icon" />
                  Genera Firma per Mac (Apple Mail)
                </button>
              </div>
            </form>

            {emlFileName && <AppleMailInstructions fileName={emlFileName} />}
          </div>
        </div>
      </div>
    </>
  );
};
